import React from 'react';

import { TabType } from './TagTabs';

interface ITabContent {
  tabs: TabType[];
  activeTab: TabType;
  contentClassName?: string;
}

function TabContent({ tabs, activeTab, contentClassName }: ITabContent) {
  return (
    <div className={contentClassName}>
      {tabs.map((tab) => (
        <div
          data-testid="tag-tab-content-item"
          key={tab.name}
          style={{
            display: tab.name === activeTab.name ? 'block' : 'none',
          }}
        >
          {tab.ContentComponent && <tab.ContentComponent />}
        </div>
      ))}
    </div>
  );
}

export default TabContent;